import React from 'react';
import yunzhiLogo from '@/asserts/images/footer/yunzhi.svg';
import makeLogo from '@/asserts/images/footer/make.svg';
import kmLogo from '@/asserts/images/footer/km.svg';
import s from './index.module.less';

const CSS_PROPERTIES = {
  width: 1280,
};

const ExternalModule = () => (
  <div className={s.unionWrap} style={CSS_PROPERTIES}>
    <div className={s.union}>
      <div className={s.supName}>柔性代码工作室 由 CSIG 质量部 / 工程效能研发中心维护</div>
      <div className={s.externalLinks}>
        <a href="https://csig.lexiangla.com/teams/k100495" target="_blank" rel="noreferrer">
          <img src={yunzhiLogo} alt="" />
        </a>
        <a href="https://mk.woa.com/coterie/50?ADTAG=search" target="_blank" rel="noreferrer">
          <img src={makeLogo} alt="" />
        </a>
        <a href="https://km.woa.com/knowledge/8917" target="_blank" rel="noreferrer">
          <img src={kmLogo} alt="" />
        </a>
      </div>
    </div>
  </div>
);

export default ExternalModule;
